module.exports = __webpack_public_path__ + "static/media/javaAnimation.a26225bc.png";